import { createTheme } from '@mui/material/styles';

// Define the universal theme based on the Analysis page styling
export const appTheme = createTheme({
  palette: {
    primary: {
      main: '#3b82f6', // blue-500 from Tailwind
      light: '#60a5fa', // blue-400 from Tailwind
      dark: '#2563eb', // blue-600 from Tailwind
    },
    secondary: {
      main: '#8b5cf6', // purple-500 from Tailwind
      light: '#a78bfa', // purple-400 from Tailwind
      dark: '#7c3aed', // purple-600 from Tailwind
    },
    error: {
      main: '#ef4444', // red-500 from Tailwind
    },
    warning: {
      main: '#f59e0b', // amber-500 from Tailwind
    },
    info: {
      main: '#3b82f6', // blue-500 from Tailwind
    },
    success: {
      main: '#10b981', // green-500 from Tailwind
    },
    text: {
      primary: '#111827', // gray-900 from Tailwind
      secondary: '#4b5563', // gray-600 from Tailwind
    },
    background: {
      default: '#ffffff',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Open Sans", "Roboto", "Helvetica", "Arial", sans-serif',
    h1: {
      fontSize: '2.5rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h2: {
      fontSize: '2rem',
      fontWeight: 700,
      lineHeight: 1.2,
    },
    h3: {
      fontSize: '1.5rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h4: {
      fontSize: '1.25rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h5: {
      fontSize: '1.125rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    h6: {
      fontSize: '1rem',
      fontWeight: 600,
      lineHeight: 1.2,
    },
    body1: {
      fontSize: '1rem',
      lineHeight: 1.5,
      color: '#4b5563', // gray-600 from Tailwind
    },
    body2: {
      fontSize: '0.875rem',
      lineHeight: 1.5,
      color: '#6b7280', // gray-500 from Tailwind
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
    },
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem',
          boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
          border: '1px solid rgba(59, 130, 246, 0.1)', // primary color with 10% opacity
          background: 'transparent',
          backdropFilter: 'blur(8px)',
          position: 'relative',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem',
          textTransform: 'none',
          fontWeight: 500,
          padding: '0.5rem 1rem',
        },
        contained: {
          boxShadow: 'none',
          '&:hover': {
            boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: '0.75rem',
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          borderRadius: '0.5rem',
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          color: '#111827', // gray-900 from Tailwind
        },
      },
    },
  },
});

// CSS variables for use with Tailwind classes
export const cssVariables = {
  colors: {
    primary: '#3b82f6',
    secondary: '#8b5cf6',
    success: '#10b981',
    error: '#ef4444',
    warning: '#f59e0b',
    info: '#3b82f6',
    textPrimary: '#111827',
    textSecondary: '#4b5563',
  },
  fontSizes: {
    h1: '2.5rem',
    h2: '2rem',
    h3: '1.5rem',
    h4: '1.25rem',
    h5: '1.125rem',
    h6: '1rem',
    body1: '1rem',
    body2: '0.875rem',
  },
  fontWeights: {
    light: 300,
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
};

export default appTheme;
